import dayjs from "dayjs"

export const getTime = (date: string, format: string) => {
  return dayjs(date).format(format)
}
